module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_01_6NX26_1SF_HV9.eedcc409.jpg";